'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { InternalProvider, useComponentDeprecation } from '../../util';
import { SelectionChip } from './SelectionChip';
import { ChipsContainerElement } from './elements';
import { useHorizontalScroll } from './useHorizontalScroll';

/** @deprecated */
export const SelectionChips = ({
  id,
  className = '',
  size = 'small',
  type = 'selection',
  layout = 'wrap',
  chips = [],
  options = {
    multiSelect: true,
    defaultSelectionIndex: null
  },
  onSelectionChange,
  ...rest
}) => {
  useComponentDeprecation({
    name: 'SelectionChips',
    version: 'v5',
    alternative: 'the new FilterChip'
  });
  const [activeChipIndex, setActiveChipIndex] = useState(0);
  const chipsRefs = [];
  const [selectedChips, setSelectedChips] = useState(chips.filter(({
    isSelected
  }) => isSelected));
  const scrollRef = useRef(null);
  const isMoving = useHorizontalScroll(layout === 'nowrap' ? scrollRef : null);
  useEffect(() => {
    onSelectionChange === null || onSelectionChange === void 0 || onSelectionChange(selectedChips);
  }, [selectedChips]);
  useEffect(() => {
    if (options.defaultSelectionIndex) {
      setSelectedChips([chips[options.defaultSelectionIndex]]);
    }
  }, []);
  const getIsSelected = useCallback(chip => selectedChips.includes(chip), [selectedChips]);
  const makeChipActive = chip => {
    const selectedChipIndex = chips.findIndex(theChip => theChip.label === chip.label);
    if (selectedChipIndex !== activeChipIndex) {
      chipsRefs[selectedChipIndex].tabIndex = 0;
      chipsRefs[activeChipIndex].tabIndex = -1;
      setActiveChipIndex(selectedChipIndex);
    }
  };
  const onClickHandler = chip => {
    if (isMoving) return;
    if (options.multiSelect) {
      if (getIsSelected(chip)) {
        setSelectedChips(prevSelected => prevSelected.filter(({
          label
        }) => label !== chip.label));
      } else {
        setSelectedChips(prevSelected => [...prevSelected, chip]);
      }
    } else {
      setSelectedChips([chip]);
      makeChipActive(chip);
    }
    chip.onClick && chip.onClick();
  };
  const handleKeyDown = e => {
    if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
      setActiveChipIndex((activeChipIndex + chips.length - 1) % chips.length);
      chipsRefs[(activeChipIndex + chips.length - 1) % chips.length].focus();
    } else if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
      setActiveChipIndex((activeChipIndex + 1) % chips.length);
      chipsRefs[(activeChipIndex + 1) % chips.length].focus();
    }
  };
  const handleBlur = ({
    currentTarget
  }) => {
    requestAnimationFrame(() => {
      if (!currentTarget.contains(document.activeElement) && !!selectedChips.length) {
        makeChipActive(selectedChips[0]);
      }
    });
  };
  return /*#__PURE__*/React.createElement(InternalProvider, null, /*#__PURE__*/React.createElement(ChipsContainerElement, _extends({
    "data-aui": "chips.selection",
    ref: scrollRef,
    id: id,
    className: className,
    tabIndex: -1,
    $layout: layout,
    onKeyDown: !options.multiSelect ? handleKeyDown : undefined,
    onBlur: !options.multiSelect ? handleBlur : undefined,
    role: !options.multiSelect ? 'radiogroup' : undefined
  }, rest), chips.map((chip, i) => /*#__PURE__*/React.createElement(SelectionChip, _extends({
    ref: ref => chipsRefs[i] = ref,
    key: chip.label
  }, chip, {
    type: type,
    size: size,
    isSelected: getIsSelected(chip),
    onClick: () => onClickHandler(chip),
    tabIndex: options.multiSelect ? null : activeChipIndex === i ? 0 : -1,
    ariaChecked: activeChipIndex === i,
    role: options.multiSelect ? 'checkbox' : 'radio',
    edgeItemsMargin: options.edgeItemsMargin
  })))));
};